// extracted by mini-css-extract-plugin
export default {"desktopOnly":"responsive_elements__desktopOnly--JEvA","mobileOnly":"responsive_elements__mobileOnly--kEs1"};